import { KANBAN_SORT_OPTIONS } from '../utils/KanbanDealSort.js';

const STORAGE_KEY = 'quickcrm_kanban_sort_prefs';

const DEFAULT = { key: 'updatedAt', dir: 'desc' };

export function getKanbanSortPref(stageKey) {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        const all = raw ? JSON.parse(raw) : {};
        return all[stageKey] || { ...DEFAULT };
    } catch {
        return { ...DEFAULT };
    }
}

export function saveKanbanSortPref(stageKey, pref) {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        const all = raw ? JSON.parse(raw) : {};
        all[stageKey] = { key: pref.key, dir: pref.dir };
        localStorage.setItem(STORAGE_KEY, JSON.stringify(all));
    } catch { /* ignore */ }
}

export function getDefaultDirForSortKey(key) {
    return KANBAN_SORT_OPTIONS.find(o => o.key === key)?.defaultDir || 'desc';
}
